<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("estatistica", 2) }}
        </h1>
      </div>
    </div>
    <EstatisticasCharts />
  </div>
</template>

<script>
import EstatisticasCharts from './components/EstatisticasCharts.vue';
export default {
  components: { EstatisticasCharts },
};
</script>
